/* eslint-disable react/sort-comp */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { Table, Menu, Icon, Dropdown, Modal, Button, Input, Form, Avatar } from 'antd';
import Layout from '../Layout';
import DataTable from '../../components/DataTable';
import './Tab.css';

class Tab extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    // eslint-disable-next-line
    error: PropTypes.string,
    get: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
  };

  state = {
    searchTimeout: null,
    filter: {},
    page: {
      number: 0,
      size: 10,
    },
    sort: []
  };

  // eslint-disable-next-line react/sort-comp
  actions = [
    { key: 'edit', icon: 'edit', title: 'Edit' },
    { key: 'delete', icon: 'delete', title: 'Delete' },
  ];

  styles = {
    filtersBlock: { marginBottom: '16px', display: 'none!important' },
    createButton: { width: '100%', margin: '4px 0 16px' },
  };

  onAddBtnClick = this.onAddBtnClick.bind(this);
  onTableActionClick = this.onTableActionClick.bind(this);
  onFilterChange = this.onFilterChange.bind(this);
  onSearchClick = this.onSearchClick.bind(this);
  renderFiltersBlock = this.renderFiltersBlock.bind(this);
  resetFilters = this.resetFilters.bind(this);
  onChangePagination = this.onChangePagination.bind(this);
  onTableFilterChange = this.onTableFilterChange.bind(this);

  componentWillMount() {
    if (this.props.location.search) {
      this.addSearchParamsToState(this.getData);
    } else {
      this.getData();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { search } = this.props.location;

    window.onpopstate = () => {
      if (search && search !== prevProps.location.search) {
        this.addSearchParamsToState(this.getData);
      } else if (!search) {
        this.setState({
          page: {
            ...this.state.page,
            number: 0,
          },
        }, this.getData);
      }
    };
  }

  componentWillUnmount() {
    this.props.resetState();
  }

  getData() {
    const { filter, page, sort } = this.state;
    this.addParamsToUrl();
    this.props.get({ filter, page, sort });
  }

  addParamsToUrl = () => {
    const { page, sort } = this.state;
    let { filter } = this.state;
    const { history } = this.props;

    if (!filter.search) {
      delete filter.search;
    }

    const searchString = qs.stringify({ page, filter, sort });

    history.push({
      pathname: history.location.pathname,
      search: searchString,
    });
  };

  addSearchParamsToState = (callBack) => {
    const { filter, page, sort } = this.state;
    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const newState = {
      filter: Object.entries(params.filter || {}).reduce((r, [key, value]) => {
        if (value) {
          if (['categories', 'types'].includes(key)) {
            r[key] = value.map((item) => +item);
          } else {
            r[key] = value;
          }
        }
        return r;
      }, filter || {}),

      page: params.page ? {
        number: +params.page.number,
        size: +params.page.size
      } : page,

      sort: params.sort || sort || []
    }

    this.onParamsParseDone(newState);

    this.setState(newState, callBack);
  };

  onParamsParseDone(state) {

  }

  parseQuerySort(state, columns, columnIndex, columnKey = 'dataIndex') {
    const sort = (state.sort || []).find(({column, order}) => column === columns[columnIndex][columnKey]);
    if (sort) {
      columns[columnIndex].defaultSortOrder = sort.order === 'asc' ? 'ascend' : 'descend';
    }
  }

  tableActions() {
    return {
      key: 'actions',
      title: 'Actions',
      dataIndex: 'actions',
      fixed: 'right',
      width: 50,

      render: (text, data) => {
        const menu = (
          <Menu onClick={this.onTableActionClick}>
            {this.actions.map(a => (
              <Menu.Item key={a.key} data-id={data.id}>
                <Icon type={a.icon} />
                <span>{a.title}</span>
              </Menu.Item>
            ))}
          </Menu>
        );

        return (
          <Dropdown overlay={menu}>
            <div>
              <Icon type="bars" />
              <Icon type="down" />
            </div>
          </Dropdown>
        );
      },
    };
  }

  appendPath(path) {
    const { history } = this.props;
    const res = history.location.pathname.replace(/\/$/gi, '')
      .concat(`/${path}`);
    history.push(res);
  }

  onAddBtnClick() {
    this.appendPath('new');
  }

  onTableActionClick(item) {
    const { 'data-id': id } = item.item.props;

    // eslint-disable-next-line
    switch (item.key) {
      case 'delete':
        this.renderDeleteConfirm(id);
        break;

      case 'edit':
        this.appendPath(id);
        break;
    }
  }

  onChangePagination(number, size) {
    const page = { number: number - 1, size };

    this.setState({ page }, () => {
      this.getData();
      // this.addParamsToUrl();
    });
  }

  onFilterChange(event) {
    const { name, value } = event.target;

    this.setState({
      filter: { ...this.state.filter, [name]: value },
      page: { ...this.state.page, number: 0 },
    }/*, this.addParamsToUrl*/);
  }

  onSearchClick() {

    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    const searchTimeout = setTimeout(function () {
      this.getData();
    }.bind(this), 300);

    this.setState({ searchTimeout: searchTimeout });

  }

  onTableFilterChange(pagination, filter,  sortItem) {
    this.setState(prev => {
      // const sort = prev.sort.filter(item => item.column !== sortItem.field);

      // if (sortItem.order) {
      //   sort.push({ column: sortItem.field, order: sortItem.order === 'ascend' ? 'asc' : 'desc' })
      // }

      return {
        page: { ...prev.page, number: 0 },
        filter: { ...filter, search: this.state.filter.search },
        sort: sortItem.field && sortItem.order ? [{ column: sortItem.field, order: sortItem.order === 'ascend' ? 'asc' : 'desc' }] : []
      }
    }, this.getData);
  }

  resetFilters() {
    this.setState({ filter: {} });
    this.getData();
  }

  renderFiltersBlock(searchElements) {
    if (searchElements) {
      return (
        <Form
          style={this.styles.filtersBlock}
          border=""
          layout="inline"
          onChange={this.onSearchClick}
        >
          {searchElements}
          <Form.Item>
            {/*
            <Button className="buttonSearch"
                    disabled={false}
                    onClick={this.onSearchClick}
            >Search</Button>
            <Button className="buttonSearch"
                    disabled={false}
                    fixed="right"
                    onClick={this.resetFilters}>Reset</Button>
            */}
          </Form.Item>
        </Form>
      );
    }

    return null;
  }

  renderDeleteConfirm(id) {
    Modal.confirm({
      title: 'Are you sure delete this item?',
      onOk: () => {
        const { filter, page } = this.state;
        this.props.remove(id, filter, page);
      },
    });
  }

  renderCreateButton(title = 'Create') {
    return (
      <Button
        style={this.styles.createButton}
        type="primary"
        onClick={this.onAddBtnClick}
      >
        {title}
      </Button>
    );
  }

  renderSearchInput(name, placeholder) {
    return (
      <Form.Item>
        <Input
          key="input"
          name={name}
          placeholder={placeholder}
          value={this.state.filter[name]}
          onChange={this.onFilterChange}
          disabled={false}
        />
      </Form.Item>
    );
  }

  renderDataTable(pagination = true) {

    if (pagination) {
      return (
        <DataTable
          loading={this.props.isLoading}
          scroll={{ x: 1000 }}
          columns={this.columns}
          data={this.props.data}
          currentPage={this.state.page.number}
          pageSize={this.state.page.size}
          onChangePagination={this.onChangePagination}
          onChange={this.onTableFilterChange}
        />
      );
    } else {
      return (
        <Table
          key="table"
          loading={this.props.isLoading}
          rowKey="id"
          columns={this.columns}
          dataSource={this.props.data && this.props.data.results}
          pagination={false}
          onChange={this.onTableFilterChange}
        />
      );
    }
  }

  render() {
    return (
      <Layout>
        {this.renderDataTable()}
      </Layout>
    );
  }
}

export default Tab;



// WEBPACK FOOTER //
// ./src/containers/Tab/index.js